import React from 'react';
import { PantryScreen } from '../../src/components/pantry/PantryScreen';

export default function InventoryRoute() {
  return <PantryScreen />;
}
